import type { ReactNode } from 'react'

type Tone = 'primary' | 'secondary' | 'accent' | 'success' | 'error' | 'info' | 'warning'

const toneText: Record<Tone, string> = {
  primary: 'text-primary',
  secondary: 'text-secondary',
  accent: 'text-accent',
  success: 'text-success',
  error: 'text-error',
  info: 'text-info',
  warning: 'text-warning',
}

/**
 * Nexus stat card (matches the template's StatItem pattern): title, big value,
 * an icon chip, and an optional sub line. `icon` is an iconify class (lucide--*).
 */
export default function StatCard({
  title,
  value,
  icon,
  sub,
  tone = 'primary',
  onClick,
}: {
  title: ReactNode
  value: ReactNode
  icon: string
  sub?: ReactNode
  tone?: Tone
  onClick?: () => void
}) {
  return (
    <div
      className={`card bg-base-100 ${onClick ? 'cursor-pointer transition-colors hover:bg-base-200/40' : ''}`}
      onClick={onClick}
    >
      <div className="card-body gap-2">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="text-base-content/70 text-sm font-medium">{title}</p>
            <p className="mt-2 text-2xl font-semibold font-mono">{value}</p>
          </div>
          <div className="bg-base-200 rounded-box grid place-items-center p-2.5 shrink-0">
            <span className={`iconify ${icon} size-5 ${toneText[tone]}`} />
          </div>
        </div>
        {sub && <p className="text-base-content/60 text-sm truncate">{sub}</p>}
      </div>
    </div>
  )
}
